/**
 * <StatementFigure> — la figure d'un énoncé servie en SVG, qu'un toucher ouvre en grand (molecule).
 *
 * L'ancien `MaterialSvgDisplay` : la figure (`figure_svg`) sous le texte de l'énoncé, centrée, à 90 %
 * de la largeur ; un toucher l'ouvre dans la visionneuse (`<ImageDisplay>`, pincer, faire pivoter,
 * comme l'ancien `SvgViewer`). Une figure encore en génération n'est pas d'ici : l'énoncé la dit
 * (`figurePending`).
 *
 * Ce qui change : la figure fait 240 px de haut au téléphone (l'ancien la serrait à 80 px, illisible
 * sans l'ouvrir) et 400 px ailleurs, comme l'ancien sur le web.
 */
import React, { useState } from "react"
import { Platform, Pressable } from "react-native"
import { SvgXml } from "react-native-svg"
import { StyleSheet } from "react-native-unistyles"

import { ImageDisplay } from "../ImageDisplay"

export type StatementFigureProps = {
    /** Le SVG de la figure, tel que le serveur le sert. */
    svg: string
    testID?: string
}

const HEIGHT = Platform.OS === "web" ? 400 : 240

const TEXTS = { open: "Agrandir la figure" }

export function StatementFigure(props: StatementFigureProps) {
    const { svg, testID } = props
    // État d'interface : la visionneuse ouverte.
    const [open, setOpen] = useState(false)
    return (
        <>
            <Pressable
                onPress={() => setOpen(true)}
                style={styles.figure}
                accessibilityRole="imagebutton"
                accessibilityLabel={TEXTS.open}
                testID={testID}
            >
                <SvgXml xml={svg} width="90%" height={HEIGHT} />
            </Pressable>
            <ImageDisplay visible={open} images={[{ uri: "", svg }]} onClose={() => setOpen(false)} />
        </>
    )
}

const styles = StyleSheet.create((theme) => ({
    // La figure est dessinée pour une feuille blanche (traits et cotes sombres) : elle garde sa feuille
    // en mode sombre, comme les pages d'une copie.
    figure: {
        alignItems: "center",
        justifyContent: "center",
        borderRadius: theme.radius.md,
        paddingVertical: theme.spacing["2"],
        backgroundColor: theme.colors.white,
    },
}))
